import { render, staticRenderFns } from "./PrintProductItemInfo.vue?vue&type=template&id=e5d3d9e6&scoped=true&"
import script from "./PrintProductItemInfo.vue?vue&type=script&lang=js&"
export * from "./PrintProductItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrintProductItemInfo.vue?vue&type=style&index=0&id=e5d3d9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d3d9e6",
  null
  
)

export default component.exports